import {charcoal} from '../../sass/v2/_exports.sass';

export const BulletedListIcon = ({color = charcoal, className = '', ratio = 1}) => {
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};
  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Bulleted list</title>
      <path
        d="M9.76932 12.077V10.077H27.3333V12.077H9.76932ZM9.76932 17V15H27.3333V17H9.76932ZM9.76932 21.9231V19.9231H27.3333V21.9231H9.76932ZM5.74366 12.154C5.43855 12.154 5.18276 12.0496 4.97632 11.8407C4.76988 11.6318 4.66666 11.3729 4.66666 11.064C4.66666 10.7627 4.76988 10.51 4.97632 10.306C5.18276 10.102 5.43855 10 5.74366 10C6.04876 10 6.30455 10.102 6.51099 10.306C6.71743 10.51 6.82066 10.7627 6.82066 11.064C6.82066 11.3729 6.71743 11.6318 6.51099 11.8407C6.30455 12.0496 6.04876 12.154 5.74366 12.154ZM5.74366 17.064C5.43855 17.064 5.18276 16.962 4.97632 16.758C4.76988 16.5543 4.66666 16.3016 4.66666 16C4.66666 15.682 4.76988 15.4209 4.97632 15.2167C5.18276 15.0124 5.43855 14.9103 5.74366 14.9103C6.04876 14.9103 6.30455 15.0124 6.51099 15.2167C6.71743 15.4209 6.82066 15.682 6.82066 16C6.82066 16.3016 6.71743 16.5543 6.51099 16.758C6.30455 16.962 6.04876 17.064 5.74366 17.064ZM5.74366 22C5.43855 22 5.18276 21.8956 4.97632 21.6867C4.76988 21.4777 4.66666 21.2191 4.66666 20.9103C4.66666 20.6088 4.76988 20.356 4.97632 20.152C5.18276 19.948 5.43855 19.846 5.74366 19.846C6.04876 19.846 6.30455 19.948 6.51099 20.152C6.71743 20.356 6.82066 20.6088 6.82066 20.9103C6.82066 21.2191 6.71743 21.4777 6.51099 21.6867C6.30455 21.8956 6.04876 22 5.74366 22Z"
        fill={color}
      />
    </svg>
  );
};
